import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TTemplateRowAction } from '../columns/templateColumns';
import type { ISampleTemplate } from '../sampleData';
import RowActionsMenu from './RowActionsMenu';

interface IProps {
  onAction: (template: ISampleTemplate, action: TTemplateRowAction) => void;
  template: ISampleTemplate;
}

function TemplateRowActions({ onAction, template }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <RowActionsMenu
      actions={[
        { action: 'edit', label: t('Edit') },
        { action: 'duplicate', label: t('Duplicate') },
        { action: 'rename', label: t('Rename') },
        {
          action: 'delete',
          isDestructive: true,
          label: t('Delete'),
          showDividerBefore: true,
        },
      ]}
      onAction={(action): void => onAction(template, action as TTemplateRowAction)}
    />
  );
}

export default TemplateRowActions;
